var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F6F5",
    fillRule: "evenodd",
    d: "M10.087 11.62a5 5 0 1 0 3.826-9.238 5 5 0 0 0-3.826 9.237M20 19v2H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5",
    clipRule: "evenodd"
  })));
};
export default SvgProfileIcon;